const solidShadows = [
  // shadows light
  "[box-shadow:0px_1px_2px_0px_rgba(31,31,31,0.15),0px_0px_0px_2px_rgba(255,255,255,0.15)_inset,0px_-2px_0px_0px_rgba(31,31,31,0.15)_inset]",
  // shadows dark
  "dark:[box-shadow:0px_1px_2px_0px_rgba(255,255,255,0.15),0px_0px_0px_2px_rgba(31,31,31,0.15)_inset,0px_-2px_0px_0px_rgba(255,255,255,0.15)_inset]",
];

const auxiliaryShadows = [
  //shadows light
  "[box-shadow:0px_1px_2px_0px_rgba(31,31,31,0.05),0px_0px_0px_1px_rgba(31,31,31,0.08)_inset,0px_-2px_0px_0px_rgba(31,31,31,0.08)_inset]",
  "hover:[box-shadow:0px_1px_2px_0px_rgba(31,31,31,0.15),0px_0px_0px_1px_rgba(31,31,31,0.15)_inset,0px_-2px_0px_0px_rgba(31,31,31,0.08)_inset]",
  // shadows dark
  "dark:[box-shadow:0px_1px_2px_0px_rgba(255,255,255,0.08),0px_0px_0px_1px_rgba(255,255,255,0.15)_inset,0px_-2px_0px_0px_rgba(255,255,255,0.08)_inset]",
  "dark:hover:[box-shadow:0px_1px_2px_0px_rgba(255,255,255,0.15),0px_0px_0px_1px_rgba(255,255,255,0.15)_inset,0px_-2px_0px_0px_rgba(255,255,255,0.08)_inset]",
];

const cardShadows = [
  //shadows light
  "[box-shadow:0px_2px_2px_0px_rgba(31,31,31,0.05),0px_0px_0px_1px_rgba(31,31,31,0.15)_inset,0px_-2px_0px_0px_rgba(31,31,31,0.05)_inset]",
  "hover:[box-shadow:0px_2px_2px_0px_rgba(31,31,31,0.05),0px_0px_0px_1px_rgba(31,31,31,0.15)_inset,0px_-2px_0px_0px_rgba(31,31,31,0.05)_inset]",
  // shadows dark
  "dark:[box-shadow:0px_2px_2px_0px_rgba(255,255,255,0.05),0px_0px_0px_1px_rgba(255,255,255,0.15)_inset,0px_-2px_0px_0px_rgba(255,255,255,0.05)_inset]",
  "dark:hover:[box-shadow:0px_2px_2px_0px_rgba(255,255,255,0.05),0px_0px_0px_1px_rgba(255,255,255,0.15)_inset,0px_-2px_0px_0px_rgba(255,255,255,0.05)_inset]",
];

const innerShadow = [
  // shadows light
  "[box-shadow:0px_0px_0px_1px_rgba(31,31,31,0.02)_inset,0px_-1.3px_0px_0px_rgba(31,31,31,0.1)_inset]",
  // shadows dark
  "dark:0px_0px_0px_1px_rgba(255,255,255,0.02)_inset,0px_-1.3px_0px_0px_rgba(255,255,255,0.1)_inset]",
];

const tertiaryShadow = [
  // shadows light
  "[box-shadow:0px_1px_2px_0px_hsl(var(--ui-tertiary-200))]",
  // shadows dark
  "dark:[box-shadow:0px_1px_2px_0px_hsl(var(--ui-tertiary-200))]",
];

export { solidShadows, auxiliaryShadows, innerShadow, cardShadows, tertiaryShadow };
